import React, { useContext } from "react";
import Nav from "./Nav";
import SidebarPro from "./SidebarPro";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Login from "../../pages/Login";
import { useDispatch, useSelector } from "react-redux";
import { getUserError, getUserStatus, getUserToken, sessionOut } from "../../store/slices/userSlice";
import Dashboard from "../../pages/Dashboard";
import Userlist from "../../pages/UserList";
import FishEdList from "../../pages/FishEdList";
import TermsAndConditions from "../../pages/TermsAndConditions";
import PrivacyPolicy from "../../pages/PrivacyPolicy";
import Spinner from "../Spinner";
import { context } from "../../context/context";
import AboutUs from "../../pages/AboutUs";
import AllSpecies from "../../pages/AllSpecies";
import Points from "../../pages/Points";
import PointTableList from "../../pages/PointTableList";
import AllLakes from "../../pages/AllLakes";
import AllSeasons from "../../pages/AllSeasons";
import { useProSidebar } from "react-pro-sidebar";
import Announcements from "../../pages/Announcements";
import PlayersRanking from "../../pages/PlayersRanking";
import QuickStats from "../../pages/QuickStats";
import Posts from "../../pages/Posts";

const Layout = () => {
  const { isLoading } = useContext(context);
  const { collapsed } = useProSidebar();
  const status = useSelector(getUserStatus);
  const authToken = useSelector(getUserToken);
  const error = useSelector(getUserError);
  const dispatch = useDispatch();
  if (error == 401) {
    dispatch(sessionOut());
    localStorage.clear();
  }
  let toggleClass = collapsed ? "main-collapse-div" : "main-div";
  return (
    <>
      {status == "loading" || isLoading ? <Spinner /> : <></>}
      <div className={!authToken ? "" : "wrapper"}>
        <BrowserRouter>
          {authToken && error != 401 ? (
            <>
              <SidebarPro />
              <div className={toggleClass}>
                <Nav />
                <Routes>
                  <Route path="*" element={<Navigate to="/dashboard" />} />
                  <Route path="/dashboard" exact element={<Dashboard />} />
                  <Route path="/specie-list" exact element={<AllSpecies />} />
                  <Route path="/season-list" exact element={<AllSeasons />} />
                  <Route path="/quick-stats" exact element={<QuickStats />} />
                  <Route path="/players-ranking/:_id" exact element={<PlayersRanking />} />
                  <Route path="/announcements" exact element={<Announcements />} />
                  <Route path="/specie-points" exact element={<Points />} />
                  <Route path="/point-table" exact element={<PointTableList />} />
                  <Route path="/user-list" exact element={<Userlist />} />
                  <Route path="/fish-ed" exact element={<FishEdList />} />
                  <Route path="/lake-list" exact element={<AllLakes />} />
                  <Route path="/terms-and-conditions" exact element={<TermsAndConditions />} />
                  <Route path="/about-us" exact element={<AboutUs />} />
                  <Route path="/posts" exact element={<Posts />} />
                  <Route path="/privacy-policy" exact element={<PrivacyPolicy />} />
                </Routes>
              </div>
            </>
          ) : (
            <>
              <Routes>
                <Route path="*" element={<Navigate to="/" />} />
                <Route path="/" exact element={<Login />} />
              </Routes>
            </>
          )}
        </BrowserRouter>
      </div>
    </>
  );
};

export default Layout;
